/* @flow */

import * as React from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { getEventId } from '@braindate/domain/lib/event/util';

import { getAuthenticationToken } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import { fetchEvent } from 'src/shared/domain/event/action/eventActions';
import useEvent from 'src/shared/domain/event/hook/useEvent';
import { getEvent } from 'src/shared/domain/event/selector/eventSelectors';
import { fetchMembershipOptimally } from 'src/shared/domain/membership/action/membershipActions';
import useMembership from 'src/shared/domain/membership/hook/useMembership';
import useLocations from 'src/shared/domain/location/hook/useLocations';
import { fetchSelfOptimally } from 'src/shared/domain/user/action/userActions';
import useSelf from 'src/shared/domain/user/hook/useSelf';
import { fetchLocations } from 'src/shared/domain/location/action/locationActions';

export default function useInitialPayloadFetching() {
  const token = useSelector(getAuthenticationToken);
  const dispatch = useDispatch();
  const user = useSelf();
  const membership = useMembership();
  const safeEvent = useEvent();
  const privateEvent = useSelector(getEvent, shallowEqual);
  const locations = useLocations();

  React.useEffect(() => {
    if (token) {
      const eventId = getEventId(safeEvent);

      if (!user) {
        dispatch(fetchSelfOptimally(eventId));
      }

      if (!membership) {
        dispatch(fetchMembershipOptimally(eventId));
      }

      if (!privateEvent) {
        dispatch(fetchEvent(eventId));
      }

      if (!locations.length) {
        dispatch(fetchLocations(eventId));
      }
    }
  }, [token]);
}
